"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = require("./utils/common");
var config_1 = require("./utils/config");
var consoler_1 = require("./utils/consoler");
var eventsHelper_1 = require("./utils/eventsHelper");
var fileHelper_1 = require("./utils/fileHelper");
var htmlHelper_1 = require("./utils/htmlHelper");
var iconHelper_1 = require("./utils/iconHelper");
var typeHelper_1 = require("./utils/typeHelper");
var urlHelper_1 = require("./utils/urlHelper");
var Utils = /** @class */ (function () {
    function Utils() {
        this.common = common_1.default;
        this.config = config_1.default;
        this.consoler = consoler_1.default;
        this.eventsHelper = eventsHelper_1.default;
        this.fileHelper = fileHelper_1.default;
        this.htmlHelper = htmlHelper_1.default;
        this.iconHelper = iconHelper_1.default;
        this.typeHelper = typeHelper_1.default;
        this.urlHelper = urlHelper_1.default;
    }
    return Utils;
}());
exports.default = Utils;
